import { defineMessages } from 'react-intl';

export default defineMessages({
  variable: 'Variable',
  stable: 'Stable',
});
